import { FiltersList, FilterTypes } from '@portal/shared/ui/filter';

export const bundlesFiltersList: FiltersList[] = [
  {
    selector: 'appName',
    title: 'Application name',
    type: FilterTypes.MultipleSearch,
    data: [
      {
        text: 'Bundle name',
        id: 'bundleName',
      },

      {
        text: 'Bundle description',
        id: 'bundleDesc',
      },
    ],
  },
  {
    selector: 'deviceModel',
    title: 'Device Model',
    type: FilterTypes.Single,
    data: [
      { text: 'P630', id: 'P630' },
      { text: 'CM5', id: 'CM5' },
      { text: 'CM5P', id: 'CM5P' },
      { text: 'V660P', id: 'V660P' },
      { text: 'VM100' , id: 'VM100'},
      { text: 'VP100', id: 'VP100' },
      { text: 'VP110', id: 'VP110' },
    ],
  },
];
